import React, { createContext, useContext, useState } from "react";

const FilterContext = createContext(null);
export const useFilter = () => useContext(FilterContext) || {};

export function FilterProvider({ children }) {
  const [range, setRange] = useState({ key: "all", start: "", end: "" });
  const [role, setRole] = useState("");
  const [employee, setEmployee] = useState(""); // employee name (links by stable record fields)

  return (
    <FilterContext.Provider value={{ range, setRange, role, setRole, employee, setEmployee }}>
      {children}
    </FilterContext.Provider>
  );
}
